import React from "react";

import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import KogSlideImages from "@/main/components/shared/kogSlideImages/kogSlideImages";
import Close from "@mui/icons-material/Close";

import * as S from "./styles";

interface IKogModalSlideImages {
	images: string[];
	imageIndex: number;
	isOpen: boolean;
	isInModal?: boolean;
	totalImages?: number;
	onLoadMore?: () => Promise<string[]>;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	downloadImage?: (url: string) => void;
}
function KogModalSlideImages({
	images,
	imageIndex,
	isOpen,
	isInModal = false,
	totalImages,
	onLoadMore,
	setIsOpen,
	downloadImage,
}: IKogModalSlideImages) {
	return (
		<KogModalFadeComponent
			open={isOpen}
			setOpen={() => {
				setIsOpen(false);
			}}
			isInModal={isInModal}
		>
			<S.CloseButton onClick={() => setIsOpen(false)} id="id-registerInventory-slideImages-icon-close">
				<Close fontSize="medium" />
			</S.CloseButton>

			<KogSlideImages
				images={images}
				imageIndex={imageIndex}
				totalImages={totalImages}
				onLoadMore={onLoadMore}
				downloadImage={downloadImage}
			/>
		</KogModalFadeComponent>
	);
}

export default KogModalSlideImages;
